import { useEffect, useState } from 'react';
import { crmApi } from '../../api/crm.js';
import { useAuth } from '../../contexts/AuthContext.jsx';

export default function Contacts() {
  const { can } = useAuth();
  const [items, setItems] = useState([]);
  const [companies, setCompanies] = useState([]);
  const [search, setSearch] = useState('');
  const [showForm, setShowForm] = useState(false);

  function refresh() { crmApi.contacts({ search }).then((d) => setItems(d?.items || [])); }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { refresh(); /* eslint-disable-next-line */ }, [search]);
  useEffect(() => { crmApi.companies().then((d) => setCompanies(d?.items || [])); }, []);

  async function submit(e) {
    e.preventDefault();
    const fd = new FormData(e.currentTarget);
    await crmApi.createContact({
      name: fd.get('name'),
      email: fd.get('email') || null,
      phone: fd.get('phone') || null,
      companyId: fd.get('companyId') || null,
      role: fd.get('role') || null,
      source: fd.get('source') || null,
    });
    e.currentTarget.reset();
    setShowForm(false);
    refresh();
  }

  return (
    <section>
      <header className="page-header">
        <h1>Contacts</h1>
        {can('contact', 'create') && <button className="btn primary" onClick={() => setShowForm((s) => !s)}>{showForm ? 'Close' : '+ New Contact'}</button>}
      </header>
      {showForm && (
        <form onSubmit={submit} className="card form-card grid-form">
          <label>Name<input name="name" required /></label>
          <label>Email<input name="email" type="email" /></label>
          <label>Phone<input name="phone" /></label>
          <label>Role<input name="role" /></label>
          <label>Source<input name="source" placeholder="referral, web, …" /></label>
          <label>Company
            <select name="companyId">
              <option value="">—</option>
              {companies.map((c) => <option key={c.id} value={c.id}>{c.name}</option>)}
            </select>
          </label>
          <div className="full actions"><button className="btn primary" type="submit">Create</button></div>
        </form>
      )}

      <div className="card form-card grid-form">
        <label className="full">Search<input value={search} onChange={(e) => setSearch(e.target.value)} placeholder="name or email" /></label>
      </div>

      <div className="card">
        <table className="data-table">
          <thead><tr><th>Name</th><th>Email</th><th>Phone</th><th>Company</th><th>Role</th><th>Owner</th></tr></thead>
          <tbody>
            {items.map((c) => (
              <tr key={c.id}>
                <td><strong>{c.name}</strong></td>
                <td>{c.email || '—'}</td>
                <td>{c.phone || '—'}</td>
                <td>{c.company_name || '—'}</td>
                <td className="muted">{c.role || '—'}</td>
                <td className="muted">{c.owner_name || '—'}</td>
              </tr>
            ))}
            {items.length === 0 && <tr><td colSpan={6} className="muted">No contacts yet.</td></tr>}
          </tbody>
        </table>
      </div>
    </section>
  );
}
